import { Component, OnInit, Input } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';
import { IndependenceModel } from 'src/app/analytic-report/declaration.model';
import { ClientShortModel } from 'src/app/models/client-short.model';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-my-client',
  templateUrl: './my-client.component.html',
  styleUrls: ['./my-client.component.css'],
})
export class MyClientComponent implements OnInit {
  selectedClient;
  clientList: ClientShortModel[];
  clientIndependence: IndependenceModel;

  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) {}

  ngOnInit(): void {
    this.selectedClient="";
    this.masterDataService.getClientsForEmployee(localStorage.getItem('id')).subscribe((res) => {
      this.clientList = res;
    });
  }

  onViewReport() {
    if(this.selectedClient==undefined|| this.selectedClient==""||this.selectedClient==null){
      this.commonMessageService.swalAlertWithoutIcon('',"Please Select Client Name.");
      return;
    }
    this.masterDataService
      .getClientIndependence(
        this.selectedClient.clientId,
        localStorage.getItem('id'),
        1
      )
      .subscribe(res => {
        console.log("resp",res)
        this.clientIndependence = res;
        console.log("clientIndependence",this.clientIndependence);
        if(this.clientIndependence== null){
          this.commonMessageService.swalAlertWithoutIcon('','No Record Found.');
        }
      });
  }
}
